(ns ui.view.transaction-process.modals.declaration.model
  "Pure state helpers for the declaration modal. The form draft is a flat map
  living under the TP state-path at `[:ui :modal-form]`.")

(defn init-create-state
  "The draft keys its entity values by the real `:declaration/*` attributes, so the
  form reads directly as an entity (no short-key translation for the
  mandatoriness/gate helpers or the save payload). The plain keys are modal meta.
  `slot-kw` is the TP named ref this declaration links to (sent as `:slot-attr`)."
  [{:keys [slot-kw declaration-type-label]}]
  {:edit-mode?                  false
   :slot-kw                     slot-kw
   :declaration-type-label      declaration-type-label
   :draft?                      true
   :submitting?                 false
   :error                       nil
   :declaration/not-applicable? false
   :declaration/completed?      false
   :declaration/date            nil
   :declaration/comment         ""})

(defn init-edit-state
  "Pure: caller resolves the declaration entity from session and passes it in.
  `slot-kw` is supplied by the caller; the slot identity comes from the
  layout/panel that opened the modal."
  [{:keys [declaration slot-kw declaration-type-label]}]
  {:edit-mode?                  true
   :entity-id                   (:db/id declaration)
   :original                    declaration
   :slot-kw                     slot-kw
   :declaration-type-label      declaration-type-label
   :draft?                      (boolean (:declaration/draft? declaration))
   :submitting?                 false
   :error                       nil
   :declaration/not-applicable? (boolean (:declaration/not-applicable? declaration))
   :declaration/completed?      (boolean (:declaration/completed? declaration))
   :declaration/date            (:declaration/date declaration)
   :declaration/comment         (or (:declaration/comment declaration) "")})

(defn ->create-entity
  "The slot the declaration links to is sent as `:slot-attr` by the create event."
  [{:keys [draft?]
    :declaration/keys [not-applicable? completed? date comment]} declaration-id]
  (cond-> {:db/id                        declaration-id
           :entity/type                  :entity.type/declaration
           :declaration/draft?           (boolean draft?)
           :declaration/not-applicable?  (boolean not-applicable?)
           :declaration/completed?       (boolean (and completed? (not not-applicable?)))}
    date          (assoc :declaration/date date)
    (seq comment) (assoc :declaration/comment comment)))

(defn- original-comment
  [original]
  (or (:declaration/comment original) ""))

(defn ->update-attrs
  [{:keys [draft? original] :declaration/keys [not-applicable? completed? date comment]}]
  (cond-> {:declaration/draft?          (boolean draft?)
           :declaration/not-applicable? (boolean not-applicable?)
           :declaration/completed?      (boolean (and completed? (not not-applicable?)))}
    (not= (:declaration/date original) date)
    (assoc :declaration/date date)

    (not= (original-comment original) comment)
    (assoc :declaration/comment (not-empty comment))))
